// --------------------------------------------------------------------------
// eventSlider.js
// --------------------------------------------------------------------------
// Slick sliders for the What's on section
// --------------------------------------------------------------------------

EC.eventSlider = function () {

    'use strict';

    let $detailSlider;
    let $imagerySlider;

    function init () {
        $detailSlider = $('.js-event-slider-details');
        $imagerySlider = $('.js-event-slider-imagery');

        if($detailSlider.length && $imagerySlider.length){
            initSliders();
            $('.js-event-slider-next').on('click', nextSlide);
            $imagerySlider.find('.slick-dots button').on('click', dotNavigation);
            $imagerySlider.on('afterChange', animateIn);
        }
    }

    function initSliders () {
        $detailSlider.slick({
            arrows: false,
            draggable: false
        });
        $imagerySlider.slick({
            asNavFor: '.js-event-slider-details',
            arrows: false,
            fade: true,
            dots: true
        });
        animateIn();
    }

    function nextSlide () {
        const $currentSlide = $imagerySlider.find('.slick-current');

        $currentSlide.removeClass('b-event-slide--is-active');
        setTimeout(function(){
            $imagerySlider.slick('slickNext'); 
        }, 500);
    }

    function animateIn () {
        const $currentSlide = $imagerySlider.find('.slick-current');
        
        $currentSlide.addClass('b-event-slide--is-active');
    }

    function dotNavigation () {
        const $currentSlide = $imagerySlider.find('.slick-current');
        const targetSlide = parseInt(this.textContent) - 1;

        $currentSlide.removeClass('b-event-slide--is-active');
        setTimeout(function(){
            $imagerySlider.slick('slickGoTo', targetSlide); 
        }, 500);

        return false;
    }

    return {
        init: init
    };

}();